export const GET_EMAIL_LOGS = 'GET_EMAIL_LOGS';

export function emailLogs(data, callback) {
  return {
    type: GET_EMAIL_LOGS,
    payload: {data, callback},
  }; 
}